export default {
  title: 'Włącz powiadomienia o ofertach i aktualnościach',
  description: 'Śledź zamówienie na bieżąco. Sprawdzaj status dostawy. Ekskluzywne promocje i korzyści.',
  buttons: {
    confirm: 'Włącz',
    cancel: 'Nie teraz',
  },
};
